import React, {useState, useCallback} from 'react'
import {Field} from 'redux-form'
import ScrollRequired from '@cred/react-scrollable/ScrollRequired'
import PropTypes from 'prop-types'

const ScrollRequiredDisclosure = ({
  slug,
  name,
  ctaText,
  errorMessage,
  validate,
  children,
  scrollRequiredProps,
  ...props
}) => {
  const [scrolled, setScrolled] = useState(false),
    isDisclosureViewed = useCallback(
      () => !scrolled ? errorMessage : null,
      [scrolled, errorMessage]
    ),
    validations = [isDisclosureViewed, validate]
  return (
    <Field
      name={name}
      component={ScrollRequired}
      validate={validations}
      scrolled={scrolled}
      setScrolled={setScrolled}
      {...{...props, ...scrollRequiredProps}}
    >
      {children}
    </Field>
  )
}

ScrollRequiredDisclosure.propTypes = {
  slug: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]).isRequired,
  errorMessage: PropTypes.string,
  validate: PropTypes.func
}

ScrollRequiredDisclosure.defaultProps = {
  validate: () => {},
  errorMessage: 'Scroll to the bottom of the box to continue',
  scrollRequiredProps: {}
}

export default ScrollRequiredDisclosure
